import { ButtonBase, Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	selected: boolean;
	onClick?: () => void;
	bordered?: boolean;
	children: ReactNode;
};

export const InspirationChoiceTile: FC<Props> = ({
	selected,
	onClick,
	bordered = false,
	children,
}) => {
	const theme = useTheme();

	if (!onClick) {
		return (
			<Stack
				flex={1}
				alignItems="center"
				p={theme.spacingTokens.md}
				borderRadius={theme.radii.lg}
				bgcolor={
					selected ? theme.palette.blue[50] : theme.palette.surface.muted
				}
				border={
					bordered
						? theme.colors.border.solid(
								selected ? theme.palette.blue[200] : "transparent",
							)
						: undefined
				}
			>
				{children}
			</Stack>
		);
	}

	return (
		<ButtonBase
			onClick={onClick}
			aria-pressed={selected}
			sx={{
				flex: 1,
				flexDirection: "column",
				justifyContent: "flex-start",
				p: theme.spacingTokens.md,
				borderRadius: theme.radii.lg,
				bgcolor: selected
					? theme.palette.blue[50]
					: theme.palette.surface.muted,
				border: bordered
					? theme.colors.border.solid(
							selected ? theme.palette.blue[200] : "transparent",
						)
					: undefined,
				"&:active": { transform: "scale(0.98)" },
			}}
		>
			{children}
		</ButtonBase>
	);
};
